import { gql } from '@apollo/client';

import { StudentActivity } from '@ts-core/modules/activities/types';
import { studentActivityFragment } from '../fragments';

export interface GetActivityQueryVariables {
  courseId: string;
  activityId: string;
}

export interface GetActivityQueryResult {
  activity: StudentActivity;
}

export const getActivityQuery = gql`
  query GetActivityQuery($courseId: String!, $activityId: String!) {
    activity(courseId: $courseId, activityId: $activityId) @rest(type: "Activity", path: "courses/{args.courseId}/activities/{args.activityId}") {
      ...StudentActivity
    }
  }
  ${studentActivityFragment}
`;
